import React, { useState, useEffect, useRef } from "react";

const slides = [
  { src: "/kuku-assets/images/banner_2.png", alt: "Kuku Namkeen Slider 1" },
  { src: "/kuku-assets/images/slider2.png", alt: "Kuku Namkeen Slider 2" },
  { src: "/kuku-assets/images/slider3.png", alt: "Kuku Namkeen Slider 3" },
];

const HomeSlider = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const next = () => setCurrent((c) => (c + 1) % slides.length);
  const prev = () => setCurrent((c) => (c - 1 + slides.length) % slides.length);

  useEffect(() => {
    timerRef.current = setInterval(next, 4000);
    return () => clearInterval(timerRef.current);
  }, []);

  const resetTimer = (fn) => {
    clearInterval(timerRef.current);
    fn();
    timerRef.current = setInterval(next, 4000);
  };

  return (
    <>
      <style>{`
        .my-carousel { position: relative; width: 100%; overflow-x: hidden; }
        .my-carousel-inner { position: relative; width: 100%; overflow: hidden; }
        .my-carousel-track {
          display: flex;
          width: 100%;
          transition: transform 0.6s ease-in-out;
        }
        .my-carousel-item { flex: 0 0 100%; width: 100%; margin-top: 45px; }
        .my-carousel-control-prev, .my-carousel-control-next {
          position: absolute; top: 0; bottom: 0; z-index: 1;
          display: flex; align-items: center; justify-content: center;
          width: 15%; padding: 0; color: #fff; text-align: center;
          background: 0 0; border: 0; opacity: .5; transition: opacity .15s ease;
        }
        .my-carousel-control-prev:hover, .my-carousel-control-next:hover { opacity: .9; }
        .my-carousel-control-prev { left: 0; }
        .my-carousel-control-next { right: 0; }
        .my-carousel-control-prev-icon, .my-carousel-control-next-icon {
          display: inline-block; width: 2rem; height: 2rem;
          background-repeat: no-repeat; background-position: 50%; background-size: 100% 100%;
        }
        .my-carousel-control-prev-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
        }
        .my-carousel-control-next-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
        }
        .my-carousel-indicators {
          position: absolute; right: 0; bottom: 0; left: 0; z-index: 2;
          display: flex; justify-content: center; padding: 0;
          margin-right: 15%; margin-bottom: 1rem; margin-left: 15%; list-style: none;
        }
        .my-carousel-indicators button {
          box-sizing: content-box; flex: 0 1 auto; width: 30px; height: 3px;
          padding: 0; margin-right: 3px; margin-left: 3px; text-indent: -999px;
          cursor: pointer; background-color: #fff; background-clip: padding-box;
          border: 0; border-top: 10px solid transparent; border-bottom: 10px solid transparent;
          opacity: .5; transition: opacity .6s ease;
        }
        .my-carousel-indicators button.active { opacity: 1; }
      `}</style>
      <section className="navigation-space my-carousel">
        <div className="my-carousel-indicators">
          {slides.map((_, i) => (
            <button
              type="button"
              key={i}
              className={i === current ? "active" : ""}
              aria-current={i === current ? "true" : "false"}
              aria-label={`Slide ${i + 1}`}
              onClick={() => resetTimer(() => setCurrent(i))}
            ></button>
          ))}
        </div>
        <div className="my-carousel-inner">
          <div
            className="my-carousel-track"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {slides.map((slide, i) => (
              <div className="my-carousel-item" key={i}>
                <img src={slide.src} className="d-block w-100" alt={slide.alt} style={{ width: "100%", display: "block" }} />
              </div>
            ))}
          </div>
        </div>
        <button
          className="my-carousel-control-prev"
          type="button"
          onClick={() => resetTimer(prev)}
        >
          <span className="my-carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clipPath: "inset(50%)" }}>Previous</span>
        </button>
        <button
          className="my-carousel-control-next"
          type="button"
          onClick={() => resetTimer(next)}
        >
          <span className="my-carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden" style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clipPath: "inset(50%)" }}>Next</span>
        </button>
      </section>
    </>
  );
};

export default HomeSlider;
